import React from 'react';
import './Workflow.css';

// Import the new API image
import apiImage from '../../assets/images/workflow-api.png';

const Workflow = () => {
  return (
    <section className="workflow-section">
      <div className="workflow-container">
        {/* Left Column: Text Content */}
        <div className="workflow-text-col">
          <h2>Plug it into your workflow, seamlessly</h2>
          <p>
            We've made it easy to bring CRISHI's data right into your day-to-day tools. Whether you prefer APIs or Excel plugins, you can pull exactly what you need, when you need it — without jumping platforms or copying files. It's our data, your way.
          </p>
        </div>

        {/* Right Column: Image */}
        <div className="workflow-image-col">
          <img src={apiImage} alt="API and workflow integration graphic" />
        </div>
      </div>
    </section>
  );
};

export default Workflow;